import { render, staticRenderFns } from "./setTime.vue?vue&type=template&id=74fdee30&scoped=true&"
import script from "./setTime.vue?vue&type=script&lang=js&"
export * from "./setTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fdee30",
  null
  
)

export default component.exports